import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import CountryLogo from 'components/CountryLogo/CountryLogo';
import NavBar from 'components/NavBar/NavBar';
import withDrawerState, { WithDrawerProps } from 'enhancers/withDrawerState';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import styled from 'styled-components';

type Props = WithDrawerProps &
  RouteComponentProps<any> & {
    className?: string;
    color: string;
  };

export const MobileHeader: React.SFC<Props> = props => {
  const toggle = () => props.toggleDrawer(!props.open);
  return (
    <Container style={{ color: props.color }} className={props.className}>
      <Wrapper>
        <Logo color={props.color} />
        <Icon onClick={toggle}>
          {props.open ? (
            <CloseIcon style={{ fontSize: 35 }} />
          ) : (
            <MenuIcon style={{ fontSize: 35 }} />
          )}
        </Icon>
      </Wrapper>
      <Nav style={props.open ? { height: 300 } : {}}>
        <NavBar color={props.color} />
        {props.children}
      </Nav>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  width: 100%;
  padding: 20px;
  background: white;
  z-index: 1000;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;

const Icon = styled.div`
  cursor: pointer;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Nav = styled.div`
  transition: all 0.4s ease 0s;
  height: 0;
  overflow: hidden;
`;

const Logo = styled(CountryLogo)`
  width: 50px;
`;

export default withRouter(withDrawerState(MobileHeader));



// WEBPACK FOOTER //
// ./src/components/Header/MobileHeader.tsx